import { Box, Button } from '@chakra-ui/react';

interface FilterButtonProps {
  handleClearAll(): void;
  handleDefaultButton(): void;
}

export const FilterButton = ({handleDefaultButton, handleClearAll}: FilterButtonProps) => {
  return (
    <Box
      display={'flex'}
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'center'}
      color={'rgba(0, 144, 198, 1)'}
    >
      <Button
        marginRight={'20px'}
        marginLeft={'10px'}
        variant={'ghost'}
        onClick={handleClearAll}
        border={'none'}
        _hover={{ textDecoration: 'underline', border: 'none' }}
        padding={0}
        color={'rgba(0, 144, 198, 1)'}
      >
        RESTORE TO DEFAULT
      </Button>
      <Button
        variant={'ghost'}
        border={'none'}
        onClick={handleDefaultButton}
        _hover={{ textDecoration: 'underline', border: 'none' }}
        padding={0}
        color={'rgba(0, 144, 198, 1)'}
      >
        SAVE AS DEFAULT
      </Button>
    </Box>
  );
};
